<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closeCloseBranchDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode"
            [class.zx-ltr]="!isRTL">
            <ng-container *ngIf="!updateRequested">
                <span>{{ "close-branch.title-1" | translate }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ "choose-branch.naming." + getPrintingService() + "." + branch | translate }}</span>
                <span class="zx-100-opp">-</span>
                <span>{{ "close-branch.title-2" | translate }}</span>
            </ng-container>
            <ng-container *ngIf="updateRequested">
                <span>{{ "close-branch.success-title" | translate }}</span>
                <span>{{ "choose-branch.naming." + getPrintingService() + "." + branchName | translate }}</span>
                <span>{{ "close-branch.success-title-suffix" | translate }}</span>
            </ng-container>
        </h4>

        <div class="d-flex flex-column gap-3 align-items-center w-100 pt-3">
            <span class="text-center pb-4" [class.zx-ltr]="!isRTL">
                <ng-container *ngIf="!updateRequested">
                    {{ close_msg }}
                </ng-container>
                <ng-container *ngIf="updateRequested">
                    {{ "close-branch.success-message-part1" | translate }}
                    <span class="d-inline-flex align-items-center gap-1 gap-lg-2">
                        <span>{{ userPhone }}</span>
                        <button mat-icon-button 
                            class="phone-edit-button d-flex align-items-center justify-content-center p-0"
                            [matTooltip]="'close-branch.edit-phone-tooltip' | translate"
                            (click)="onEditPhone()">
                            <img *ngIf="!isDarkMode" src="assets/images/chainge-icon.svg" class="svg zx-small-icon-size c-pointer">
                            <img *ngIf="isDarkMode" src="assets/images/chainge-icon-green.svg" class="svg zx-small-icon-size c-pointer">
                        </button>
                    </span>
                    {{ "close-branch.success-message-part2" | translate }}
                </ng-container>
            </span>
            <button color="primary" mat-raised-button class="rounded-pill w-100 text-white"
                (click)="closeCloseBranchDialog()">
                {{ "close-branch.btn" | translate }}
            </button>
            <button *ngIf="!updateRequested" mat-button 
                class="rounded-pill w-100 notify-button d-flex align-items-center justify-content-center gap-2"
                [disabled]="isLoadingUpdates"
                (click)="onRequestUpdateWhenBranchOpens()">
                <mat-icon *ngIf="!isLoadingUpdates">sms</mat-icon>
                <span>{{ (isLoadingUpdates ? "close-branch.loading" : "close-branch.notify-when-opens") | translate }}</span>
            </button>
        </div>

    </div>
</div>